<!-- 智能诊股行情头部 -->
<template>
<div>
 
    <div class="diagnosis-header"> 
        <div class="diagnosis-header__brand">
            <img class="diagnosis-header__logo" src="https://cdncos.aigupiao.com/assets/wap/img/logo216_216.png" alt="爱股票">
            <span class="diagnosis-header__content">
                <strong class="diagnosis-header__title">爱股票 – 专业股市投资者社区</strong>
                <span class="swiper-container diagnosis-header__quote" v-if="indexList.length">
                    <span class="swiper-wrapper">
                        <span class="swiper-slide" v-for="item in indexList" :key="item.code">
                            <span class="diagnosis-header__index-name">{{ item.name }}</span>
                            <span :class="item.isUp ? 'diagnosis-header__red' : 'diagnosis-header__green'">
                                {{ item.price }} ({{ item.percentText }}%)
                            </span>
                            <img class="diagnosis-header__trend" :src="item.isUp ? upIcon : downIcon" alt="">
                        </span>
                    </span>
                </span>
            </span>
        </div>

        <div class="diagnosis-header__dots" v-if="indexList.length > 1">
            <button
                v-for="(item, index) in indexList"
                :key="item.code"
                type="button"
                :class="['diagnosis-header__dot', { 'diagnosis-header__dot--active': currentIndexNumber === index }]"
                :aria-label="'查看' + item.name"
                @click="selectIndex(index)"
            ></button>
        </div>

        <a class="diagnosis-header__download" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui">下载APP</a>
    </div>
    <div class="device_shadow" v-if="0"></div>
</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
    name: 'WapHeader2',
    data: function() {
        return {
            quoteUrl: 'https://igp-img-upload-1251605428.cos.ap-shanghai.myqcloud.com/cos_data/quote_query_index_pc.json',
            upIcon: 'https://cdn.aigupiao.com/static/wrap/img/index_ico_top.png',
            downIcon: 'https://cdn.aigupiao.com/static/wrap/img/index_ico_bottom2.png',
            indexList: [],
            currentIndexNumber: 0,
            quoteSwiper: null,
            rotationTimer: null
        };
    },
    computed: {
        currentIndex: function() {
            return this.indexList.length ? this.indexList[this.currentIndexNumber] : null;
        }
    },
    created: function() {
        //this.getIndexQuotes();
        this.setIndexQuotes({"CHA50CFD_s":"14638.07,-26.93,-0.18,富时A50指数","HKHSI_s":"24981.77,-293.19,-1.16,恒生指数","HKHSTECH_s":"4338.34,-82.45,-1.87,恒生科技指数","USHXC_s":"5826.91,-124.08,-2.09,纳指中国金龙","USI:COMP_s":"26253.34,-168.07,-0.64,纳斯达克","USI:DJI_s":"52380.66,-405.41,-0.77,道琼斯","USI:SP500_s":"7636.36,-37.16,-0.48,标普500","bj899050_s":"1059.35,-22.46,-2.08,北证50","sh000001_s":"3938.86,-12.65,-0.32,上证指数","sh000016_s":"2905.59,-4.81,-0.17,上证50","sh000300_s":"4553.65,-18.95,-0.41,沪深300","sh000688_s":"1567.71,-12.35,-0.78,科创50","sz399001_s":"13622.07,-101.25,-0.74,深证成指","sz399006_s":"3336.88,-18.09,-0.54,创业板指"});
    },
    beforeDestroy: function() {
        if (this.quoteSwiper) {
            this.quoteSwiper.destroy(true, true);
            this.quoteSwiper = null;
        }
        this.stopRotation();
    },
    methods: {
        getIndexQuotes: function() {
            var self = this;
            var xhr = new XMLHttpRequest();
            xhr.open('GET', this.quoteUrl + '?time=' + new Date().getTime(), true);
            xhr.onreadystatechange = function() {
                var response;
                if (xhr.readyState !== 4) {
                    return;
                }
                if (xhr.status < 200 || xhr.status >= 300) {
                    return;
                }
                try {
                    response = JSON.parse(xhr.responseText);
                } catch (error) {
                    return;
                }
                self.setIndexQuotes(response);
            };
            xhr.send(null);
        },
        setIndexQuotes: function(data) {
            var definitions = [
                { code: 'sh000001_s', name: '上证指数' },
                { code: 'sz399001_s', name: '深证成指' },
                { code: 'sz399006_s', name: '创业板指' }
            ];
            var result = [];
            var i;
            var item;
            for (i = 0; i < definitions.length; i += 1) {
                item = this.parseIndexQuote(definitions[i], data && data[definitions[i].code]);
                if (item) {
                    result.push(item);
                }
            }
            this.indexList = result;
            this.currentIndexNumber = 0;
            this.$nextTick(function() {
                this.initQuoteSwiper();
            });
        },
        parseIndexQuote: function(definition, value) {
            var fields;
            var percent;
            if (typeof value !== 'string') {
                return null;
            }
            fields = value.split(',');
            if (fields.length < 3) {
                return null;
            }
            percent = parseFloat(fields[2]);
            if (isNaN(percent)) {
                percent = 0;
            }
            return {
                code: definition.code,
                name: definition.name,
                price: this.formatNumber(fields[0]),
                percentText: (percent >= 0 ? '+' : '') + percent.toFixed(2),
                isUp: percent >= 0
            };
        },
        formatNumber: function(value) {
            var number = parseFloat(value);
            return isNaN(number) ? '--' : number.toFixed(2);
        },
        selectIndex: function(index) {
            this.currentIndexNumber = index;
            if (this.quoteSwiper) {
                this.quoteSwiper.slideToLoop(index);
            }
        },
        initQuoteSwiper: function() {
            var self = this;
            if (this.quoteSwiper) {
                this.quoteSwiper.destroy(true, true);
            }
            this.quoteSwiper = new Swiper('.diagnosis-header__quote', {
                direction: 'horizontal',
                loop: this.indexList.length > 1,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false
                },
                speed: 500,
                observer: true,
                observeParents: true,
                on: {
                    slideChange: function() {
                        self.currentIndexNumber = this.realIndex || 0;
                    }
                }
            });
        },
        startRotation: function() {
            var self = this;
            this.stopRotation();
            if (this.indexList.length < 2) {
                return;
            }
            this.rotationTimer = window.setInterval(function() {
                self.currentIndexNumber = (self.currentIndexNumber + 1) % self.indexList.length;
            }, 3500);
        },
        stopRotation: function() {
            if (this.rotationTimer) {
                window.clearInterval(this.rotationTimer);
                this.rotationTimer = null;
            }
        }
    }
};
</script>

<style scoped>
.diagnosis-header,
.diagnosis-header * {
    box-sizing: border-box;
}

.diagnosis-header {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    width: 100%;
    height: 58px;
    padding: 0 14px;
    background: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}

.diagnosis-header__brand {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    min-width: 0;
    color: #333333;
    text-decoration: none;
}

.diagnosis-header__logo {
    display: block;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 39px;
    height: 39px;
    border-radius: 10px;
}

.diagnosis-header__content {
    display: block;
    min-width: 0;
    margin-left: 9px;
}

.diagnosis-header__title {
    display: block;
    overflow: hidden;
    color: #222222;
    font-size: 11px;
    font-weight: 600;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.diagnosis-header__quote {
    display: block;
    overflow: hidden;
    font-size: 10px;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;

}

.diagnosis-header__index-name {
    margin-right: 8px;
    color: #575A5E;
    font-weight: bolder;
}

.diagnosis-header__red {
    color: #fe484a;
    font-weight: bolder;
}

.diagnosis-header__green {
    color: #09a879;
    font-weight: bolder;
}

.diagnosis-header__trend {
    display: inline-block;
    width: 8px;
    height: 11px;
    margin-left: 4px;
    vertical-align: -1px;
    margin-top: 1px;
}

.diagnosis-header__dots {
    position: absolute;
    right: 32px;
    bottom: 12px;
    height: 5px;
    white-space: nowrap;
}

.diagnosis-header__dot {
    display: inline-block;
    width: 4px;
    height: 4px;
    margin-left: 4px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: #d8d8d8;
    vertical-align: top;
}

.diagnosis-header__dot--active {
    background: #fe484a;
}

.diagnosis-header__download {
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 57px;
    height: 21px;
    border: 1px solid #fe484a;
    border-radius: 17px;
    color: #fe484a;
    font-size: 11px;
    text-align: center;
    text-decoration: none;
    position: absolute;
    right: 16px;
    top: 10px;
}
.device_shadow{
    width: 100%;
    height: 9.5px;
    background: linear-gradient(180deg, rgba(247, 247, 247, 0.9) 0%, rgba(247, 247, 247, 0.0001) 100%);
}
/* @media screen and (max-width: 350px) {
    .diagnosis-header {
        padding-right: 10px;
        padding-left: 10px;
    }

    .diagnosis-header__content {
        margin-left: 7px;
    }

    .diagnosis-header__title {
        max-width: 165px;
        font-size: 14px;
    }

    .diagnosis-header__quote {
        font-size: 12px;
    }

    .diagnosis-header__download {
        width: 64px;
        font-size: 13px;
    }

    .diagnosis-header__dots {
        right: 81px;
    }
} */
</style>
